<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBbtdwYOxBg-pnwcNSKmIw0O86uBHStozI" async defer></script>
<div class="flex-grow-1">
    <div class="card mt-4 heading">
        <div class="table-responsive">
            <table class="table table-sm card-table table-wrap" aria-labelledby="tableLabel" *ngIf="data?.location">
                <thead>
                    <tr>
                        <th class="description">Location</th>
                        <th class="count">Pins</th>
                        <th class="count">Positions</th>
                        <th class="count">Containers</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="description">{{ data.location.displayName }}</td>
                        <td class="count">{{ data.pinsTotal }}</td>
                        <td class="count">{{ data.positionsTotal }}</td>
                        <td class="count">{{ data.containersTotal }}</td>
                    </tr>
                </tbody>        
                <tbody class="list">
                    <tr>
                        <td class="h-2" colspan="8"></td>
                    </tr>
                </tbody>             
            </table>
        </div>
    </div>            
    <div  class="col-md-12 col-12 pr-1 flex-grow-1 d-flex flex-column">
          <div appSetHeight [padding]="70" class="map">
            <div class="map-container">
              <div class="map-frame" #mapdiv>
                <div id="map"></div>
              </div>
            </div>
          </div>
    </div>
</div>